'use strict';

/* eslint-disable */ function getFragmentData(_documentNode, fragmentType) {
    return fragmentType;
}
function makeFragmentData(data, _fragment) {
    return data;
}
function isFragmentReady(queryNode, fragmentNode, data) {
    var _queryNode___meta__, _fragDef_name;
    const deferredFields = (_queryNode___meta__ = queryNode.__meta__) == null ? void 0 : _queryNode___meta__.deferredFields;
    if (!deferredFields) return true;
    const fragDef = fragmentNode.definitions[0];
    const fragName = fragDef == null ? void 0 : (_fragDef_name = fragDef.name) == null ? void 0 : _fragDef_name.value;
    const fields = fragName && deferredFields[fragName] || [];
    return fields.length > 0 && fields.every((field)=>data && field in data);
}

exports.getFragmentData = getFragmentData;
exports.isFragmentReady = isFragmentReady;
exports.makeFragmentData = makeFragmentData;
